var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAny(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 26.458 26.458",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.28 0a.825.825 0 00-.829.827v.213c0 .459.37.828.828.828h.738v5.874c0 2.018 4.304 3.054 4.304 5.446 0 2.391-4.304 3.428-4.304 5.446v5.956h-.738a.827.827 0 00-.828.828v.212c0 .459.37.828.828.828h15.9c.459 0 .828-.37.828-.828v-.212a.827.827 0 00-.828-.828h-.736v-5.955c0-2.018-4.304-3.054-4.304-5.446 0-2.391 4.304-3.426 4.304-5.444V1.868h.736c.459 0 .828-.37.828-.828V.827A.825.825 0 0021.18 0z",
    fill: "#9084b1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAny);
export default __webpack_public_path__ + "static/media/any.e998bc9949da169d31d9d9a25baeef24.svg";
export { ForwardRef as ReactComponent };